module.exports = __webpack_public_path__ + "img/Standard-image.4b956cd0.jpg";